import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Row, Col, Card } from 'react-bootstrap';
import moment from 'moment';
import API from '../../api/api.jsx';
import { getUserInfo } from '../../reducers/selectors/selectors.jsx';
import { store } from "../../store.jsx";
import CustomToast from '../../components/toast/toast.jsx';

// 결재대기 화면에서 결재상태 클릭 시 등장하는 모달
const Sanc_002_01 = ({ showModal, handleClose, approvalDetail }) => {
    const { t }                           = useTranslation();
    const [responseData, setResponseData] = useState([]);
    const [reason, setReason]             = useState('');

    // 토스트
	const [toast, setToast]               = useState(false);
	const [text, setText]                 = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await API.fetchSanc00201Data({
                    loanApplicationId : approvalDetail.loan_application_id,
                    approvalInfoId    : approvalDetail.approval_info_id,
                });

                setResponseData(data);
                setReason(data[0].refusal_reason)
            } catch (error) {
                console.error('Error in fetchSanc00201Data Error:', error);
            }
        };

        if (showModal) {
            setReason('');
            fetchData();
        }

    }, [showModal, approvalDetail]);

    // 거절 사유 변경 함수
    const handleChangeReason = async (e) => {
        setReason(e.target.value);
    };

    // 거절 버튼 클릭 시 호출되는 함수
    const handleReject = async () => {
        // 1. 현재 결재를 할 내역이 결재대기 상태인지
        if (approvalDetail.approval_status_code === 'A03') {
            alert("이미 결재완료된 내역입니다.");
            return;
        };

        if (approvalDetail.approval_status_code === 'A02') {
            alert("이미 결재가 거절된 내역입니다.");
            return;
        };

        // 1-1. 결재 거절 시에는 거절 사유가 존재하는지
        if (!reason) {
            alert(t(`LOAN_APPLICATION.거절사유를 입력하세요`, { defaultValue: '거절사유를 입력하세요' }));
            return;
        };

        // 2. 본인이 결재 권한을 가지고 있는지 (즉, 본인 차례인지)
        const userInfo = getUserInfo(store.getState());
        const user_id  = userInfo.user_id;

        if (user_id !== approvalDetail.approve_user_id) {
            alert(t(`LOAN_APPLICATION.본인의 결재 차례가 아닙니다`, { defaultValue: '본인의 결재 차례가 아닙니다' }));
            return;
        };

        try {
            const data = await API.fetchSanc00202Data({
                loanApplicationId : approvalDetail.loan_application_id,
                approvalInfoId    : approvalDetail.approval_info_id,
                reason
            });

            setText(data.message);

            setToast(true);

        } catch (error) {
            alert(error.response.data.result.content.message);
            return;
        } finally {
            handleClose(); // API 호출 후에 모달을 닫을 수 있도록 handleClose 호출
        }
    };

    let isHandlingClick = false; // 클릭 처리 여부를 나타내는 변수

    // 결재 버튼 클릭 시 호출되는 함수
    const handleApprove = async () => {
        
        // 서버에서 처리하기 전에 체크 루틴
        // 1. 현재 결재를 할 내역이 결재대기 상태인지
        if (approvalDetail.approval_status_code === 'A03') {
            alert("이미 결재완료된 내역입니다.");
            return;
        };

        if (approvalDetail.approval_status_code === 'A02') {
            alert("이미 결재가 거절된 내역입니다.");
            return;
        };
        
        // 2. 본인이 결재 권한을 가지고 있는지 (즉, 본인 차례인지)
        const userInfo = getUserInfo(store.getState());
        const user_id  = userInfo.user_id;
        
        if (user_id !== approvalDetail.approve_user_id) {
            alert(t(`LOAN_APPLICATION.본인의 결재 차례가 아닙니다`, { defaultValue: '본인의 결재 차례가 아닙니다' }));
            return;
        };

        if (isHandlingClick) return; // 클릭 처리 중이면 중복 클릭 방지

		isHandlingClick = true; // 클릭 처리 시작

        try {
            // 여기서는 API 호출 함수명과 매개변수 등을 실제 상황에 맞게 수정해야 합니다.
            const data = await API.fetchSanc00203Data({
                loanApplicationId : approvalDetail.loan_application_id,
                approvalInfoId    : approvalDetail.approval_info_id,
            });

            setText(data.message);

            setToast(true);

            handleClose(); // API 호출 후에 모달을 닫을 수 있도록 handleClose 호출

        } catch (error) {
            alert(error.response.data.result.content.message);
            console.error('API 호출 오류:', error);
            return; 
        } finally {
            isHandlingClick = false; // 클릭 처리 종료
            handleClose(); // API 호출 후에 모달을 닫을 수 있도록 handleClose 호출
        }
    };

    return (
        <>
            <CustomToast show={toast} setToast={setToast} text={text} />
            <Modal show={showModal} onHide={handleClose} centered dialogClassName="modal-lg" backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>{t(`APPROVAL.결재정보`, { defaultValue: '결재정보' })}</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className='d-flex justify-content-end ms-0 me-0'>
                        {/* 결재자 */}
                        {responseData.map((approval, index) => (
                            <Col key={index} md={2} className="ml-auto p-0">
                                <div className="border border-grey" style={{ fontSize: '12px', width: '100%', height: '100%' }}>
                                    <Row>
                                        <Col className='d-flex justify-content-center fw-bold'>
                                            {approval.name}
                                        </Col>
                                    </Row>

                                    <hr className='m-0'/>

                                    <Row>
                                        <Col className='justify-content-center pt-1' style={{ textAlign: 'center' }}>
                                            <div style={{ fontWeight: (approval.approval_status === 'A03' || approval.approval_status === 'A02') ? 'bold' : 'normal', color: approval.approval_status === 'A03' ? 'blue' : approval.approval_status === 'A02' ? 'red' : 'inherit' }}>
                                                {t(`APPROVAL_STATUS.${approval.approval_status}`, { defaultValue: `${approval.approval_status}`})}
                                            </div>

                                            {approval.approve_date ? (
                                                <div>
                                                    {moment(approval.approve_date).isValid() ? (
                                                        moment(approval.approve_date).format('DD/MM/YYYY HH:mm:ss')
                                                    ) : (
                                                        ''
                                                    )}
                                                </div>
                                            ) : (
                                                <div className="mt-3"></div>
                                            )}
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    <hr />

                    <Card>
                        {/* <Card.Header>{t(`LOAN_RECEIVABLE_INQUIRY.납부내역`, { defaultValue: '납부내역' })}</Card.Header> */}
                        <Card.Header className='d-flex justify-content-center fw-bold'>{t('APPROVAL.대출신청', { defaultValue: '대출신청' })}</Card.Header>

                        <div className='row'>
                            <div className='col-md-3 d-flex flex-column align-items-center justify-content-center pt-2 pb-2'>
                            {/* <div className='fw-bold mb-3'>{t('APPROVAL.대출신청일', { defaultValue: '대출신청일' })}</div> */}
                            <div className='fw-bold mb-3'>{t('LOAN_APPLICATION.대출예정일', { defaultValue: '대출예정일' })}</div>
                            {/* <div>{moment(approvalDetail.created_date_1).format('DD/MM/YYYY')}</div> */}
                                <div>{moment(approvalDetail.loan_date).format('DD/MM/YYYY')}</div>
                            </div>

                            <div className='col-md-3 d-flex flex-column align-items-center justify-content-center pt-2 pb-2'>
                                <div className='fw-bold mb-3'>{t('APPROVAL.고객명', { defaultValue: '고객명' })}</div>
                                <div>{approvalDetail.name}</div>
                            </div>

                            <div className='col-md-3 flex-column pt-2 pb-2'>
                                <div className='d-flex fw-bold mb-3 align-items-center justify-content-center'>{t('APPROVAL.대출금액', { defaultValue: '대출금액' })}</div>
                                <div className='d-flex align-items-center justify-content-center'>
                                    {approvalDetail.loan_amount !== null
                                        ? parseFloat(approvalDetail.loan_amount).toLocaleString('vi-VN')
                                        : 0
                                    }
                                </div>
                            </div>

                            <div className='col-md-3 d-flex flex-column align-items-center justify-content-center pt-2 pb-2'>
                                <div className='fw-bold mb-3'>{t('APPROVAL.담당자', { defaultValue: '담당자' })}</div>
                                <div>{approvalDetail.request_user_name}</div>
                            </div>
                        </div>
                    </Card>

                    <hr />

                    <Card>
                        <Card.Header className='d-flex justify-content-center fw-bold'>{t('APPROVAL.거절사유', { defaultValue: '거절사유' })}</Card.Header>
                        <textarea className='form-control' rows={5} value={reason} onChange={handleChangeReason}></textarea>
                    </Card>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between">
                    <div>
                        <button className="btn btn-outline-gray me-1 mb-1 w-100px" onClick={handleClose}>
                            <i className="fa fa-backward"></i> {t('COMMON.이전', { defaultValue: '이전' })}
                        </button>
                    </div>

                    <div>
                        <button className="btn btn-outline-danger me-1 mb-1 w-100px" onClick={handleReject}>
                            {t('APPROVAL.거절', { defaultValue: '거절' })}
                        </button>
                        <button className="btn btn-outline-success me-1 mb-1 w-100px" onClick={handleApprove}>
                            {t('APPROVAL.결재', { defaultValue: '결재' })}
                        </button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default Sanc_002_01;